import React, { Component } from 'react';
import authService from './api-authorization/AuthorizeService'
import Calendar from 'react-calendar'
import 'react-calendar/dist/Calendar.css';
import Popup from './popup/reactjs-popup.cjs.development';
import 'reactjs-popup/dist/index.css';
import { YMaps, GeolocationControl, Geolocation, Map, Placemark } from '@pbe/react-yandex-maps';
import ReactRegionSelect from 'react-region-select';
import SideNav, { ClickOutside, NavItem, NavIcon, NavText } from '@trendmicro/react-sidenav';
import AsyncSelect from 'react-select/async';
import MultiRangeSlider from "./slider/multiRangeSlider";
import DOMPurify from 'dompurify'
import { FormattedMessage } from 'react-intl';
//import Input from 'react-phone-number-input/input';
//import Select from 'react-select';
import { BookingControl } from './BookingControl';

export class Booking extends Component {
  constructor(props) {
    super(props);
    var curDate = new Date();
    curDate.setHours(0,0,0,0);
    console.log(this.props.match.params);
    //let { companyId, serviceId } = this.props.params;
    this.state = {
      companies: [],
      services: [],
      categories: [],
      orders: [],
      resources: null,
      resourcedays: [],
      calendar: [],
      filters: [],
      selectedFilters: [],
      loading: true,
      geoposition: [55.558741, 37.378847],
      zoom: 14,
      mapBounds: [],
      regions: [],
      fixedCompanyId: this.props.match.params.companyId && this.props.match.params.companyId.indexOf("all") == -1 ? parseInt(this.props.match.params.companyId) : 0,
      companyId: parseInt((this.props.match.params.companyId??"0").replace("all","")),
      serviceId: parseInt(this.props.match.params.serviceId) || 0,
      categoryIds: [],
      categoryLists: [],
      companyInfo: {userRating: 0, feedback: [], resources: []},
      resourceInfo: {userRating: 0, feedback: []},
      selectedDate: curDate,
      selectedMonth: curDate,
      expanded: false,
      duration: 1,
      phone: '+7',
      userName: '',
      partialBooking: null,
      partialBookingText: '',
      orderParams: [],
      cities: [],
      city: null,
      sort: 1
    };
    this.selectDate = this.selectDate.bind(this);
    this.selectMonth = this.selectMonth.bind(this);
    this.renderPopupContent = this.renderPopupContent.bind(this);
    this.populateCalendarData = this.populateCalendarData.bind(this);
    this.orderCreated = this.orderCreated.bind(this);
    this.selectorRef = React.createRef(null);
    this.geopositionSuccess = this.geopositionSuccess.bind(this);
    this.regionRenderer = this.regionRenderer.bind(this);
    this.handleSubmitCompanyFeedback = this.handleSubmitCompanyFeedback.bind(this);
    this.handleSubmitResourceFeedback = this.handleSubmitResourceFeedback.bind(this);
    this.debouncedLoadOptions = this.debounce(this.fetchOptions, 500);
  }

  componentDidMount() {
    this._subscription = authService.subscribe(() => this.populateState());
    this.populateState();

    this.populateCompaniesData();
    this.populateCategoriesData();
    this.populateServicesData();
    this.populateFiltersData();
    if (this.state.companyId > 0) {
      this.populateCalendarData();
    }
  }

  componentWillUnmount() {
    authService.unsubscribe(this._subscription);
  }

  async populateState() {
    const [isAuthenticated, user] = await Promise.all([authService.isAuthenticated(), authService.getUser()])
    this.setState(prevState => ({
      ...prevState,
      isAuthenticated,
      userName: user && user.name
    }));
  }

  async selectCompany(companyId) {
    await this.setState(prevState => ({...prevState, companyId: this.state.companyId !== companyId ? companyId : 0}));
    await this.populateServicesData(companyId);
    this.populateFiltersData();
    this.populateCalendarData();
  }

  async selectService(serviceId) {
    var newServiceId = this.state.serviceId !== serviceId ? serviceId : 0;
    await this.setState(prevState => ({...prevState, serviceId: newServiceId, expanded: false}));
    this.populateCompaniesData();
    if (!newServiceId) {
      this.setState(prevState => ({...prevState, regions: [], resources: null, resourceId: null, calendar: [], orders: []}));
      return;
    }
    this.populateFiltersData();
    this.populateCalendarData();
  }

  selectResource(resourceId) {
    this.setState(prevState => ({...prevState, resourceId: this.state.resourceId !== resourceId ? resourceId : null}))
  }

  async addCategory(categoryId, level, defaultServiceId) {
    var oldArray = this.state.categoryIds;
    var oldLists = this.state.categoryLists;
    var removing = oldArray.length > level + 1 && oldArray[level + 1] === categoryId;
    oldArray.length = level + 1;
    oldLists.length = level + 1;
    if (removing) {
      this.setState(prevState => ({...prevState, categoryIds: oldArray, categoryLists: oldLists, serviceId: 0, expanded: false}));
    }
    else {
      this.setState(prevState => ({...prevState, categoryIds: [...oldArray, categoryId], categoryLists: oldLists, serviceId: defaultServiceId ?? 0, expanded: !defaultServiceId}));
      this.populateCategoriesList(categoryId);
    }
    await this.populateCompaniesData();
    await this.populateServicesData();
    this.populateFiltersData();
    this.populateCalendarData();
  }

  selectTime(pos, times) {
    /*if (pos === undefined || pos === null ) {
      return;
    }
    var times = this.state.orders.filter(cal => this.state.selectedDate.getTime() === new Date(cal.date).getTime() && pos >= Math.floor(cal.start / 100) && (pos + 1) < (cal.end + 99) / 100);*/
    /*var regions = this.state.regions;
    var resourceId = this.state.resourceId;
    for (var r = 0; r < regions.length; r++) {
      for (var i = 0; i < regions[r].length; i++) {
        var orders = times.filter(cal => regions[r][i].data.resourceId === cal.resourceId);
        regions[r][i].data.disabled = orders.length>0?true:undefined;
        regions[r][i].data.regionStyle = {
          background: orders.length>0?"rgba(255, 0, 0, 0.5)":(resourceId===regions[r][i].data.resourceId?"rgba(0, 0, 255, 0.5)":"rgba(0, 255, 0, 0.5)")
        };
        if (resourceId===regions[r][i].data.resourceId && orders.length>0) {
          resourceId = undefined;
        }
      }
    }*/
    this.setState(prevState => ({...prevState, selectedTime: this.state.selectedTime !== pos ? pos : null, /*regions: regions, resourceId: resourceId,*/ filteredTimes: this.state.selectedTime !== pos ? times : null}));
  }

  addFilter(id) {
    if (this.state.selectedFilters.includes(id))
        this.setState(prevState => ({...prevState, selectedFilters: this.state.selectedFilters.filter(f => f !== id)}));
    else
        this.setState(prevState => ({...prevState, selectedFilters: [...this.state.selectedFilters, id]}));
    this.populateCalendarData();
  }

  getContent(date) {
    var slots = this.state.calendar.filter(cal => new Date(cal.day).getTime() === date.getTime());
    return (
      slots.length > 0 ? <div class="calbardiv"><span class="calredspan" style={{height: (slots[0].sumUsed * 100 / slots[0].sumHours).toString() + '%'}}></span><span class="calbarspan" style={{height: '100%'}}></span></div> : <div class="calbardiv"></div>
    );
  }

/*  increaseDuration(shift, res, maxTime, minTime) {
    var newDur = this.state.duration + shift;
    if (newDur > maxTime)
      newDur = maxTime;
    if (newDur < (minTime??res.minTime) / 3600)
      newDur = (minTime??res.minTime) / 3600;
    if (newDur !== this.state.duration)
      this.setState(prevState => ({...prevState, duration: newDur}));
    return newDur;
  }

  displayDuration(dur, res) {
    var newDur = dur;
    if (res.bookingInterval === 4)
      newDur = newDur / 24;
    return newDur;
  }

  async createOrder(resourceId, time, serviceId, date, price) {
    if (this.state.colorchange || !serviceId) {
      return;
    }
    this.setState(prevState => ({...prevState, colorchange: true}));
    setTimeout(async ()=> {
      const startTime = Date.now();
      const token = await authService.getAccessToken();

      var headers = !token ? {} : { 'Authorization': `Bearer ${token}` };
      date = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
      const response = await fetch(`{{mainApiUrl}}api/orders`, {
        method: "POST",
        headers: {
          ...headers,
          'Accept': 'application/json, text/plain',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ serviceId: serviceId, resourceId: resourceId, start: time, end: time + Math.floor(this.state.duration)*100 + this.state.duration*100%100*0.6, date: date, userPhone: this.state.phone, userName: this.state.userName, partialBooking: this.state.partialBooking, partialBookingText: this.state.partialBookingText, orderParams: this.state.orderParams.map(op => op.id), delivery: this.state.delivery, price: price })
      });
      if (!response.ok) {
        this.setState(prevState => ({...prevState, colorchange: undefined, errorBooking: "Бронирование не подтверждено"}));
        return;
      }
      const data = await response.json();
      data.date = date;
      //this.setState(prevState => ({...prevState, orders: [...prevState.orders, data]}));
      await this.populateCalendarData(true);

      const remainingTime = 3000 - (Date.now() - startTime);
      setTimeout(() => {
        this.setState(prevState => ({...prevState, orders: this.state.temporders, temporders: null, phone: '+7', userName: '', partialBooking: null, partialBookingText: '', colorchange: undefined, errorBooking: undefined, newbooking: undefined}));
        if (this.state.selectedTime)
          this.setState(prevState => ({...prevState, filteredTimes: [...this.state.filteredTimes, data]}));
      }, remainingTime > 0 ? remainingTime : 0);
    }, 0);
  }

  async cancelOrder(id) {
    const token = await authService.getAccessToken();
    var headers = !token ? {} : { 'Authorization': `Bearer ${token}` };
    const response = await fetch(`{{mainApiUrl}}api/orders/${id}`, {
      method: "DELETE",
      headers: {
        ...headers,
        'Accept': 'application/json, text/plain',
        'Content-Type': 'application/json'
      }
    });
    await response.json();
    this.setState(prevState => ({...prevState, orders: prevState.orders.filter(order => order.id !== id)}));
    this.populateCalendarData();
  }

  renderIncreaseButton(shift, res, maxTime, minTime) {
    return (
      <input style={{marginBottom: "5px"}} className="btn btn-primary" type="button" value={(shift > 0 ? '+' : '') + this.displayDuration(shift, res).toString()} id="Button_Plus05" onClick={() => this.increaseDuration(shift, res, maxTime, minTime)}/>
    );
  }

  updatePartialBookingText(evt) {
    const val = evt.target.value;
    this.setState(prevState => ({...prevState, partialBookingText: val}));
  }

  setParamOptional(val, id, price) {
    const orderParams = this.state.orderParams.filter(op => op.id !== id);
    if (val) {
      orderParams.push({id: id, price: price});
    }
    this.setState(prevState => ({...prevState, orderParams: orderParams}));
  }

  getOptionalAmount() {
    var sum = 0;
    this.state.orderParams.forEach(a => sum += a.price);
    return sum;
  }*/

  getPartialBookingSum(orders) {
    var sum = 0;
    orders.forEach(o => sum += 1 / o.partialBooking);
    return sum;
  }

  getPartialBookingText(orders) {
    var sum = 0;
    var minPart = Math.max(...orders.map(o => o.partialBooking));
    orders.forEach(o => sum += minPart / o.partialBooking);
    return `${sum} / ${minPart}`;
  }

  /*paramsExist(services) {
    if (services.length == 0)
      return false;
    var found = false;
    services[0].params?.forEach(p => {
      if (p.items.filter(i => !i.optional || i.companyServices.length > 0).length > 0) {
        found = true;
      }
    })
    return found;
  }*/

  orderCreated(data) {
    this.setState(prevState => ({...prevState, orders: this.state.temporders, temporders: null}));
    if (this.state.selectedTime)
      this.setState(prevState => ({...prevState, filteredTimes: [...this.state.filteredTimes, data]}));
  }

  renderPopupContent(pos, res, orders, min, baseOrders) {
    if (this.state.currentres?.id !== res.id || this.state.currentpos !== pos || this.state.currentmin !== min) {
      return <></>;
    }
    var closeTooltip = () => this.selectorRef.current.close();
    return <div>
          <div class="availheader">
            {res.name}
          </div>
          <BookingControl
            selectedServiceId={this.state.serviceId}
            services={this.state.services}
            selectedMonth={this.state.selectedMonth}
            selectedDate={this.state.selectedDate}
            orderParams={this.state.orderParams}
            pos={pos}
            res={res}
            orders={orders}
            min={min}
            baseOrders={baseOrders}
            isAuthenticated={this.state.isAuthenticated}
            callback={this.populateCalendarData}
            completeCallback={this.orderCreated} />
    </div>;
    /*var serviceId = this.state.serviceId > 0 ? this.state.serviceId : (this.state.selectedService?.value ?? res.services[0].serviceId);
    var service = res.services.filter(s => s.serviceId === serviceId)[0];
    if (!service) {
      return <></>;
    }

    var price = 0;
    var duration = 0;
    var deliveryDuration = 0;
    if (res.delivery !== null && (this.state.delivery || res.delivery === true) && res.deliveryBillingTime) {
      deliveryDuration = res.deliveryBillingTime;
    }
    if (service.bookingInterval == 4 && res.slots) {
      for (var curpos = pos; curpos < this.displayDuration(this.state.duration, service) + pos + deliveryDuration; curpos++) {
        const slot = res.slots.filter(s => s.day == Math.trunc(curpos))[0];
        price += (slot?.firstIntervalPrice ?? service.firstIntervalPrice) && curpos == pos ? (slot?.firstIntervalPrice ?? service.firstIntervalPrice) : (slot?.price ?? service.price);
        var intervals = slot?.firstIntervalPriceIntervals ?? service.firstIntervalPriceIntervals;
        if (intervals && curpos == pos) {
          curpos += (intervals - 1) > 0 ? (intervals - 1) : 0;
        }
      }
      duration = curpos - pos;
    } else {
      if (service.firstIntervalPrice) {
        duration = this.displayDuration(this.state.duration, service) - (service.firstIntervalPriceIntervals ? service.firstIntervalPriceIntervals : 1);
        price = service.firstIntervalPrice;
      } else {
        duration = this.displayDuration(this.state.duration, service);
      }
      duration += deliveryDuration;
      price += service.price * (duration > 0 ? duration : 0);
    }
    if (res.delivery !== null && (this.state.delivery || res.delivery === true) && res.deliveryPrice) {
      price += res.deliveryPrice;
    }
    price /= (this.state.partialBooking ? this.state.partialBooking : 1);
    var ap = 0;
    service.additionalPayments.filter(p => !p.included).forEach(p => ap += p.additionalPayment.percent ? Math.trunc(price * p.additionalPayment.amount / 100) : (p.additionalPayment.amount*(p.additionalPayment.perInterval?duration:0)));
    //price += ap;

    var selectedDate = this.getSelectedDate(pos, service.bookingInterval).toLocaleString(undefined, {weekday: "long", year: 'numeric', month: '2-digit', day: '2-digit'});
    if (orders && orders.length > 0 && !this.state.newbooking) {
      return (
        <div>
          <div><span>{orders.filter(o => o.userId).length > 0 ? <>Ваше</> : <>Уже есть</>} бронировани{orders.length > 1 ? 'я' : 'е'} на {selectedDate}</span></div>
          {orders.map(order =>
            order.userId ?
            <><div><span>Телефон: </span>{order.userPhone}</div>
            <div><span>Имя: </span>{order.userName}</div>
            {service.bookingInterval === 4 ? <></> : (<div>В {Math.floor(order.start / 100)}:{(order.start % 100).toString().padStart(2, '0')}</div>)}
            <div>Услуга: {order.service}</div>
            {service.partialBooking && order.partialBookingText ? <div>Комментарий для участников: {order.partialBookingText}</div>: <></>}
            {order.price > 0 ? <div>Цена: <b>{order.price} руб.</b></div> : <></>}
            <div className="btnbooked" id="Button_Book">Бронирование подтверждено</div>
            <div className="btncancel" id="Button_Cancel" onClick={() => {this.cancelOrder(order.id); closeTooltip();}}>X</div></> :
            (service.partialBooking && order.partialBookingText ? <div>Комментарий другого участника: {order.partialBookingText}</div> : <></>)
          )}
          {orders.length < res.count || (service.partialBooking && this.getPartialBookingSum(orders) < 1) ? <div><input style={{marginTop: "5px"}} className="btn btn-primary" type="button" value="Еще одно бронирование" id="Button_New" onClick={() => this.setState(prevState => ({...prevState, newbooking: true}))}/></div> : <></>}
        </div>
      );
    } else {
      var maxTime1 = service.maxTime/3600*100;
      var maxTime = Math.floor(pos*(service.bookingInterval==4?24:1)+maxTime1/100+min/60)*100+(((pos*(service.bookingInterval==4?24:1)+maxTime1/100+min/60)*100)%100)/100*60;
      var filteredMaxTime = baseOrders.filter(cal => res.id === cal.resourceId && (service.bookingInterval==4 || (cal.start > (pos*100+min) && cal.start < (maxTime))));
      filteredMaxTime = filteredMaxTime.filter(cal => new Date(cal.date).getTime() >= this.getSelectedDate(pos, service.bookingInterval).getTime() && new Date(cal.date).getTime()<=this.getSelectedDate((maxTime/100*3600-1)/(service.bookingInterval==4?86400:3600), service.bookingInterval).getTime());
      for (; filteredMaxTime.length > res.count - 1 && maxTime1 > 0; ) {
        maxTime1 -= (service.bookingInterval==4?2400:50);
        maxTime = Math.floor(pos*(service.bookingInterval==4?24:1)+maxTime1/100+min/60)*100+(((pos*(service.bookingInterval==4?24:1)+maxTime1/100+min/60)*100)%100)/100*60;
        filteredMaxTime = filteredMaxTime.filter(cal => res.id === cal.resourceId && (service.bookingInterval==4 || (cal.start > (pos*100+min) && cal.start < (maxTime))));
        filteredMaxTime = filteredMaxTime.filter(cal => new Date(cal.date).getTime() >= this.getSelectedDate(pos, service.bookingInterval).getTime() && new Date(cal.date).getTime()<=this.getSelectedDate((maxTime/100*3600-1)/(service.bookingInterval==4?86400:3600), service.bookingInterval).getTime());
      }
      maxTime = maxTime1 - (res.serviceTime??0)/60*100;

      var incButtons = service.timeEditable ?
          <span>{this.renderIncreaseButton(service.timeStep > 0 ? service.timeStep / 3600 : 0.5, service, maxTime/100, minTime)}
          {this.renderIncreaseButton(service.timeStep > 0 ? service.timeStep / 3600 * 2 : 1, service, maxTime/100, minTime)}</span>
        : <span></span>;
      var decButtons = service.timeEditable ?
          <span>{this.renderIncreaseButton(service.timeStep > 0 ? -service.timeStep / 3600 * 2 : -1, service, maxTime/100, minTime)}
          {this.renderIncreaseButton(service.timeStep > 0 ? -service.timeStep / 3600 : -0.5, service, maxTime/100, minTime)}</span>
        : <span></span>;

      var cancelationTime = new Date(this.getSelectedDate(pos, service.bookingInterval));
      if (service.cancelationHours)
      {
        //cancelationTime.setTime(cancelationTime.getTime()-service.cancelationHours*1000)
        cancelationTime.setDate(cancelationTime.getDate()-Math.trunc(service.cancelationHours/24/3600));
        if (service.bookingInterval != 4) {
          cancelationTime.setTime(cancelationTime.getTime()+(pos+min/60-service.cancelationHours/3600%24)*3600*1000);
        }
      }
      const optionalAmount = this.getOptionalAmount() * this.displayDuration(this.state.duration, service);
      return (
        <div>
          <div class="availheader">
            {res.name}
          </div>
          <div><span>Вы создаете бронирование на {selectedDate}</span></div>
          {service.bookingInterval === 4 ? <></> : <div>В {pos}:{(min??0).toString().padStart(2, '0')}</div>}
          {res.admin ? (
          <><div class="bookphone"><label for="telNo">Телефон</label> <Input class="phoneinput" country="RU"
            value={this.state.phone !== undefined ? this.state.phone : ''}
            onChange={val => {this.setState(prevState => ({...prevState, phone: val})); this.populateUserData();}} disabled/><span className="backsp" onClick={() => {this.setState(prevState => ({...prevState, phone: this.state.phone.length>2?this.state.phone.substring(0,this.state.phone.length-1):"+7"})); this.populateUserData();}}/></div>
            <div style={{textAlign: "center"}}>{Array.from(Array(10).keys()).map(i => <input key={i} className="btn btn-primary btn-phone" type="button" value={i==9?0:(i+1)} id={"Button_"+(i+1)} onClick={() => {this.setState(prevState => ({...prevState, phone: this.state.phone + (i==9?0:(i+1)).toString()})); this.populateUserData();}}/>)}</div>
          <div class="bookphone"><label for="uName">Имя</label> <input class="form-control" id="uName" type="text"
            value={this.state.userName !== undefined ? this.state.userName : ''}
            onChange={evt => {const val = evt.target.value; this.setState(prevState => ({...prevState, userName: val}));}}/></div></>) : (<></>)}
          {res.images && res.images.length > 0 ? <div><img style={{width: "100%"}} src={"{{mainApiUrl}}"+res.images[0]}/></div> : <></>}
          <div>Услуга: {this.state.services.filter(s => this.state.serviceId === 0 || s.id === this.state.serviceId).length > 1 ?

                      <Select
                          className="formselect"
                          classNamePrefix="select"
                          isDisabled={false}
                          isClearable={false}
                          isSearchable={true}
                          options={res.services.map(c => ({ value: c.serviceId, label: this.state.services.filter(s => s.id === c.serviceId)[0]?.name }))}
                          placeholder="Search services..."
                          noOptionsMessage={() => "Поиск не дал результатов"}
                          onChange={(newValue) => this.setState(prevState => ({...prevState, selectedService: newValue}))}
                          value={this.state.selectedService??{ value: service.serviceId, label: this.state.services.filter(s => s.id === service.serviceId)[0]?.name }}
                          name="service"
                        /> :
                        this.state.services.filter(s => this.state.serviceId === 0 || s.id === this.state.serviceId)[0]?.name
          }

          </div>
          {this.paramsExist(res.services?.filter(ser => ser.serviceId === serviceId)) ? <div><b>Параметры</b></div> : <></>}
          {res.services?.filter(ser => ser.serviceId === serviceId).length > 0 && res.services?.filter(ser => ser.serviceId === serviceId)[0].params?.map(p => p.items.filter(i => !i.optional || i.companyServices.length > 0).length > 0 ? <div style={{marginLeft: "10px"}}>{p.name ? <span>{p.name + ": "}</span> : <></>}{p.items.map(i => i.optional
          ? (i.companyServices.length > 0 ? <><input style={{margin: "5px 5px 0 3px"}} class="form-check-input" type="checkbox" id={"Input_Optional_"+i.id} name="Input.Optional"
            checked={this.state.orderParams.filter(op => op.id === i.id).length > 0}
            onChange={evt => {const val = evt.target.checked; this.setParamOptional(val, i.id, i.companyServices[0].price);}}
          />
          <label style={{display: "contents"}} for={"Input_Optional_" + i.id}>{i.name} <b>({i.companyServices[0].price} руб.)</b></label></> : <></>)
          : <span>{i.name + " "}</span>)}</div> : <></>)}
          {res.delivery === false ? <><input style={{margin: "5px 5px 0 0"}} class="form-check-input" type="checkbox" id={"Input_Delivery"} name="Input.Delivery"
            checked={this.state.delivery}
            onChange={evt => {const val = evt.target.checked; this.setState(prevState => ({...prevState, delivery: val}));}}
          /><label style={{display: "contents"}} for={"Input_Delivery"}>Доставка {res.deliveryPrice ? <b>({res.deliveryPrice} руб.)</b> : <b>бесплатно</b>}</label></> : <></>}
          {res.delivery === true ? <><label style={{display: "contents"}} for={"Input_Delivery"}>Только доставка {res.deliveryPrice ? <b>({res.deliveryPrice} руб.)</b> : <b>бесплатно</b>}</label></> : <></>}
          {service.partialBooking ?
            (<>
              <div><span className="radio-primary">
              <input name="PartialBooking" type="radio" value="RadioComplete" id="RadioComplete" checked={this.state.partialBooking === null} onClick={() => this.setState(prevState => ({...prevState, partialBooking: null}))}/><label className="btn btn-primary" for="RadioComplete">Полностью</label></span><span>Частично </span>
              <span className="radio-primary">
              {Array.from(Array(service.partialBooking + 1).keys()).map(i => i > 1 && service.partialBooking%i == 0 ? <><input name="PartialBooking" type="radio" value={'Radio' + i.toString()} id={'Radio'+i.toString()} checked={this.state.partialBooking===i} onClick={() => this.setState(prevState => ({...prevState, partialBooking: i}))}/><label className="btn btn-primary radio-gradient" for={'Radio'+i.toString()}>{'1 / ' + i.toString()}</label></> : <></>)}
              </span></div>
              {this.state.partialBooking?<div class="form-group">
                <label for="Input_PartialBookingText">Комментарий для участников</label>
                <textarea style={{marginBottom: "5px"}} class="form-control" type="text" id="Input_PartialBookingText" name="Input.PartialBookingText" value={this.state.partialBookingText} onChange={evt => this.updatePartialBookingText(evt)}/>
              </div> : <></>}
            </>)
          : <></>}
          {minTime ? <><div>Длительность</div><div> {decButtons} <span>{this.displayDuration(this.increaseDuration(0, service, maxTime/100, minTime), service)}</span> {this.getDurWord(service, this.increaseDuration(0, service, maxTime/100, minTime)*3600)} {incButtons}</div></> : <></>}
          {price + optionalAmount > 0 ? <div>Цена: <b>{price + optionalAmount} руб.</b></div> : <></>}
          {service.additionalPayments.length > 0 ? <><div><b>Налоги</b></div>
          <div style={{marginLeft: "10px"}}>
            {service.additionalPayments.map(p => <div>{p.additionalPayment.name}: {p.additionalPayment.percent?<>{p.additionalPayment.amount}% (<b>{Math.trunc(p.additionalPayment.amount*price/100)} руб.</b>)</> : <b>{p.additionalPayment.amount*(p.additionalPayment.perInterval?duration:0)} руб.</b>}{p.included ? <b> (включено)</b> : <></>}</div>)}
          </div>
            {ap > 0 ? <div>Дополнительно оплачивается: <b>{ap} руб.</b></div> : <></>}
          </> : <></>}
          {service.cancelationHours > 0 ? <div><b>Бесплатная отмена не позднее {cancelationTime.toLocaleString(undefined, {weekday: "long", year: 'numeric', month: '2-digit', day: '2-digit', hour: "2-digit", minute: "2-digit"})}</b></div> : <div><b>Отмена возможна в любое время</b></div>}
        {this.state.errorBooking ? <div style={{color: "red"}}>{this.state.errorBooking}</div> : <></>}
        {this.state.isAuthenticated?
          <div className={"btnbook"+(this.state.colorchange ? " color-change":"") + (!serviceId?" btngray":"")} id="Button_Book" disabled={!service.minTime} onClick={() => {this.createOrder(res.id, service.bookingInterval==4?0:(pos*100 + (min??0)), serviceId, this.getSelectedDate(pos, service.bookingInterval), price + ap); closeTooltip();}}>Забронировать</div>:
          <a class="btn btn-primary" href="authentication/login">Войти</a>}
          </div>
      );
    }*/
  }

  getDurWord(service, time) {
    if (service.bookingInterval == 4) {
      if (time/86400 == 1) {
        return "день";
      }
      return `дн${time/86400>=2 && time/86400<=4?"я":"ей"}`;
    }
    var word = "час";
    if (time/3600 != 1) {
      word += time/3600>=2 && time/3600<=4?"а":"ов";
    }
    return word;
  }

  onOpenPopup(pos, res, min) {
    var orderParams = [];
    var service = res.services[0];
    var serviceId = this.state.serviceId > 0 ? this.state.serviceId : service.serviceId;
    this.state.selectedFilters.forEach(sf => {
      res.services?.filter(ser => ser.serviceId === serviceId)[0].params?.forEach(p => {
        const items = p.items.filter(i => i.id === sf && i.companyServices.length > 0);
        if (items.length > 0) {
          orderParams.push({id: items[0].id, price: items[0].companyServices[0].price});
        }
      });
    });
    this.setState(prevState => ({...prevState, currentres: res, currentpos: pos, currentmin: min, orderParams: orderParams}))
  }

  RenderPopup(pos, res, orders, min) {
    var serviceId = this.state.serviceId > 0 ? this.state.serviceId : (this.state.selectedService?.value ?? res.services[0].serviceId);
    var service = res.services.filter(s => s.serviceId === serviceId)[0] ?? res.services[0];
    var filtered = orders.filter(cal => res.id === cal.resourceId && new Date(cal.date).getTime() == this.getSelectedDate(pos, service.bookingInterval).getTime() && (service.bookingInterval === 4 || ((pos*100+min) >= cal.start && (pos*100+min) < cal.end)));
    var userorders = filtered.filter(o => o.userId);

    var minTime = service.minTime;
    if (service.bookingInterval == 4 && res.slots && res.slots.filter(s => s.day == Math.trunc(pos)).length > 0 && res.slots.filter(s => s.day == Math.trunc(pos))[0].minTime) {
      minTime = res.slots.filter(s => s.day == Math.trunc(pos))[0].minTime;
    }
    if (filtered.length == 0)
    {
      var selectedTime = this.getSelectedDate(pos, service.bookingInterval, true);
      var minTimeWithService = minTime/3600*100 + (res.serviceTime??0)/60*100;
      minTimeWithService = Math.floor(minTimeWithService/100)*100+((minTimeWithService%100)/100*60);
      var filteredMinTime = orders.filter(cal => res.id === cal.resourceId && (service.bookingInterval == 4 || (cal.start > (pos*100+min) && cal.start < (pos*100+min+minTimeWithService))));
      filteredMinTime = filteredMinTime.filter(cal => new Date(cal.date).getTime() >= this.getSelectedDate(pos, service.bookingInterval).getTime() && new Date(cal.date).getTime()<=this.getSelectedDate(pos+(minTime-1)/(service.bookingInterval==4?86400:3600), service.bookingInterval).getTime());

      var serviceTime = pos*100+min/60*100+(res.serviceTime??0)/60*100;
      serviceTime = Math.floor(serviceTime/100)*100+((serviceTime%100)/100*60);
      var filteredServiceTime = filteredMinTime.filter(cal => (service.bookingInterval == 4 || (cal.start > (pos*100+min) && cal.start <= (serviceTime))));
      //filteredServiceTime = filteredServiceTime.filter(cal => new Date(cal.date).getTime() >= this.getSelectedDate(pos, service.bookingInterval).getTime() && new Date(cal.date).getTime()<=this.getSelectedDate(pos+(service.minTime-1)/(service.bookingInterval==4?86400:3600), service.bookingInterval).getTime());

      var notWorkingHours = this.isBlockedTime(pos+min/60, res, service.bookingInterval);
      var endNotWorkingHours = minTime > 0 && this.isBlockedTime(pos+min/60+(minTime-1)/(service.bookingInterval==4?86400:3600), res, service.bookingInterval);
      if (!res || new Date(res.localTime) > selectedTime || notWorkingHours || filteredMinTime.length > 0 || endNotWorkingHours) {
        return (
          <td class="calcell" title={new Date(res.localTime) > selectedTime?"":(notWorkingHours?"Нерабочее время":`${minTime != service.maxTime?"Минимальное в":"В"}ремя услуги: ${minTime/(service.bookingInterval==4?86400:3600)} ${this.getDurWord(service, service.minTime)}`)}>
            <div class={new Date(res.localTime) <= selectedTime && !notWorkingHours && (filteredServiceTime.length==0 || service.bookingInterval==4)?"blockedgreencell":"blockedcell"} style={{width: '100%'}}></div>
          </td>
        );
      }
    }
    return (
      <Popup ref={this.selectorRef}
        className="popup-book"
        trigger={open => (
          <td class="calcell" title={filtered.map(t => t.service)}>
            <div class={filtered.length>0 && filtered[0].partialBooking && this.getPartialBookingSum(filtered) < 1?"partlcell":(userorders.length>0?"bookedcell":"bookedcellimg")} style={{width: (filtered.length>0 && filtered[0].partialBooking?100:(filtered.length*100/res.count)).toString() + '%'}}>{filtered.length>0 && filtered[0].partialBooking?this.getPartialBookingText(filtered):(userorders.length>0?userorders[0].service:"")}</div>
            {filtered.length == 0 || !filtered[0].partialBooking ? <div class="availcell" style={{width: filtered.length === (res.count??1) ? '0%' : '100%'}}></div> : <></>}
          </td>
        )}
        onOpen={() => this.onOpenPopup(pos, res, min)}
        onClose={() => this.setState(prevState => ({...prevState, duration: 1, newbooking: undefined, errorBooking: undefined, orderParams: []}))}
        position="bottom center"
        closeOnDocumentClick>{() => this.renderPopupContent(pos, res, filtered, min, orders)}</Popup>
    );
  }

  getSelectedDate(pos, bookingInterval, time) {
    var date = this.state.selectedDate;
    if (bookingInterval === 4) {
      date = new Date(this.state.selectedMonth.getTime());
      date.setDate(pos);
    } else if (time) {
      date = new Date(this.state.selectedDate);
      date.setHours(pos);
    }
    return date;
  }

  RenderRow(pos) {
    var times = this.state.orders.filter(cal => /*this.getSelectedDate(pos, this.state.minBookingInterval).getTime() === new Date(cal.date).getTime() && */(this.state.minBookingInterval===4 || (pos >= Math.floor(cal.start / 100) && (pos + 1) < (cal.end + 99) / 100)));
    if (this.state.resources.filter(res => res.services.length == 0 || res.services[0].bookingInterval <= 3).length == 0) {
      //if (pos != 0) return (<></>);
      return (
        <tr key={pos}>
          <th onClick={() => this.selectTime(pos, times)} className={this.state.selectedTime === pos?'tablefix2 react-calendar__tile--active':'tablefix2'}>{pos}</th>
          {this.state.resources.filter(res => res.services.length > 0 && (!this.state.resourceId || this.state.resourceId === res.id)).map(res => this.RenderPopup(pos, res, times, 0))}
        </tr>
      );
    }
    var count = this.state.resources.filter(res => res.bookingAlignment === 4).length>0?2:1;
    count = this.state.resources.filter(res => res.bookingAlignment === 5).length>0?4:count;
    count = this.state.resources.filter(res => res.bookingAlignment === 6).length>0?12:count;
    return (
      Array.from(Array(count).keys()).map(c => <tr key={pos+"_"+c}>
        <th onClick={() => this.selectTime(pos, times)} className={this.state.selectedTime === pos?'tablefix2 react-calendar__tile--active':'tablefix2'}>{c==0?pos+':':''}{(60/count*c).toString().padStart(2, '0')}</th>
        {this.state.resources.filter(res => res.services.length > 0 && (!this.state.resourceId || this.state.resourceId === res.id)).map(res => this.RenderPopup(pos, res, this.state.orders, c==0?0:(60/count*c)))}
      </tr>)
    );
  }

  selectDate(date, event) {
    this.setState(prevState => ({...prevState, selectedDate: date}));
    if (this.state.minBookingInterval <= 3) {
      this.populateResourcesData();
      this.populateOrdersData();
    }
  }

  selectMonth({action, activeStartDate, value, view}) {
    this.setState(prevState => ({...prevState, selectedMonth: activeStartDate}));
    this.populateCalendarData();
  }

  getGeoLocation(ymaps) {
    return ymaps.geolocation
      .get({ provider: "yandex", mapStateAutoApply: true })
      .then(result =>
        ymaps.geocode(result.geoObjects.position).then(res => {
          let firstGeoObject = res.geoObjects.get(0);
          console.log(firstGeoObject.getLocalities());
          console.log(
            firstGeoObject.getLocalities().length
              ? firstGeoObject.getLocalities()
              : firstGeoObject.getAdministrativeAreas()
          );
        })
      );
  };

  mapOnLoad(ymaps) {
    //const geolocation = this.getGeoLocation(ymaps);
    //const { ymaps } = useYMaps();
    navigator.geolocation.getCurrentPosition(this.geopositionSuccess, this.error);
    /*if (navigator.geolocation) {
      navigator.permissions.query({ name: 'geolocation' }).then(function (result) {
        if (result.state === 'granted') {
          console.log(result.state);
          handleLocation();
        } else if (result.state === 'prompt') {
          console.log('prompt');
        } else if (result.state === 'denied') {
          console.log('Denied');
        }
      });
    }*/
  };

  onGeoposition() {
    if (this.state.mapZoom != 14) {
      this.setState(prevState => ({...prevState, zoom: 13}));
    }
    navigator.geolocation.getCurrentPosition(this.geopositionSuccess, this.error);
  }

  geopositionSuccess(position) {
    console.log(position);
    this.setState(prevState => ({...prevState, zoom: 14, geoposition: [position.coords.latitude, position.coords.longitude], bounds: null}));
    this.populateCurrentCity();
  }

  error() {
    console.log('geopositionError');
  }

  selectBounds(event) {
    var bounds = event.get('newBounds');
    var zoom = event.get('newZoom');
    console.log(bounds);
    console.log(zoom);
    this.setState(prevState => ({...prevState, mapBounds: bounds, mapZoom: zoom}));
  }

  onRegionChange(val) {
  }

  selectResourceRegion(region) {
    console.log(this.state.regions);
    /*var regions = this.state.regions;
    for (var i = 0; i < regions[region.data.mapIndex].length; i++) {
      if (regions[region.data.mapIndex][i].data.resourceId === this.state.resourceId) {
        regions[region.data.mapIndex][i].data.regionStyle = {
          background: "rgba(0, 255, 0, 0.5)"
        };
      }
    }
    region.data.regionStyle = {
      background: "rgba(0, 0, 255, 0.5)"
    };*/
    this.setState(prevState => ({...prevState, resourceId: region.data.resource.id/*, regions: regions*/}));
  }

  regionRenderer(regionProps) {
    if (!regionProps.isChanging/* && regionProps.data.disabled !== true*/) {
      var res = regionProps.data.resource;
      var pos = this.state.selectedTime;
      var disabled = pos && this.isBlockedTime(pos, res);
      var orders = this.state.filteredTimes ? this.state.filteredTimes.filter(cal => res.id === cal.resourceId) : [];
      if (res.id !== this.state.resourceId || (!pos && res.bookingInterval <= 3) || orders.length > 0 || disabled) {
        var background = "rgba(127, 255, 127, 0.5)";
        if (disabled)
          background = "rgba(0, 0, 0, 0.5)";
        else if (orders.length > 0)
          background = "rgba(255, 127, 127, 0.5)";
        else if (res.id === this.state.resourceId)
          background = "rgba(0, 0, 255, 0.5)";
        return ( <div onClick={() => this.selectResourceRegion(regionProps)} style={{ position: "absolute", cursor: orders.length > 0 || disabled ? "default" : "pointer", width: "100%", height: "100%", background: background }}></div> );
      }
      else {
        return (
          <Popup ref={this.selectorRef}
            className="popup-book"
            trigger={open => (
              <div style={{ position: "absolute", cursor: "pointer", width: "100%", height: "100%", background: "rgba(0, 0, 255, 0.5)"}}></div>
            )}
            position="bottom center"
            closeOnDocumentClick>{() => this.renderPopupContent(pos??0, res)}</Popup>
        );
      }
    }
  }

  async addScheme(event) {
    /*var formData = new FormData();
    formData.append("file", event.target.files[0]);

    const token = await authService.getAccessToken();
    var headers = !token ? {} : { 'Authorization': `Bearer ${token}` };
    const response = await fetch(`{{mainApiUrl}}api/companies/${this.state.companyId}/scheme`, {
      method: 'POST',
      headers: {
        ...headers,
        'Accept': 'application/json, text/plain'
      },
      body: formData
    });
    const data = await response.json();
    this.setState(prevState => ({...prevState, company: {...prevState.company, schemes: [...prevState.company.schemes, data]}, selectedScheme: prevState.company.schemes.length}));*/
  }


  updateMyCompanyFeedback(text) {
    this.setState(prevState => ({...prevState, companyInfo: {...prevState.companyInfo, userText: text.target.value}}));
  }

  async handleSubmitCompanyFeedback() {
    const token = await authService.getAccessToken();
    var headers = !token ? {} : { 'Authorization': `Bearer ${token}` };
    const response = await fetch(`{{mainApiUrl}}api/companies/${this.state.companyInfo.id}/feedback`, {
      method: "POST",
      headers: {
        ...headers,
        'Accept': 'application/json, text/plain',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ rating: this.state.companyInfo.userRating, text: this.state.companyInfo.userText })
    });


    const data = await response.json();
    var companyInfo = this.state.companyInfo;
    companyInfo.feedback = [...companyInfo.feedback, data];
    companyInfo.userText = "";
    companyInfo.userRating = 0;
    this.setState(prevState => ({...prevState, companyInfo: companyInfo}));
  }

  selectCompanyInfoImage(imageId) {
    this.setState(prevState => ({...prevState, companyInfo: {...prevState.companyInfo, selectedImage: imageId}}));
  }

  async onCompanyInfoOpen(companyId) {
    const token = await authService.getAccessToken();
    var url = `{{mainApiUrl}}api/companies/${companyId}/feedback`;
    const response = await fetch(url, {
      headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
    });
    const data = await response.json();
    this.setState(prevState => ({...prevState, companyInfo: {id: companyId, selectedImage: 0, userRating: 0, rating: data.averageRating, feedback: data.feedbackList, resources: data.resources}}));
  }

  selectCompanyUserRating(rating) {
    this.setState(prevState => ({...prevState, companyInfo: {...prevState.companyInfo, userRating: rating}}));
  }

  renderCompanyInfo(company) {
    return (
      <><div className="imagesqbig">
        <div class="imagesqbigleft">
          <img src={"{{mainApiUrl}}"+company.images[this.state.companyInfo.selectedImage]} alt="" class="schemecomp"/>
          <table className="table"><thead><tr><th>
            {company.images.map((x, i) => <div key="i" className={this.state.companyInfo.selectedImage === i?'companyimagesq react-calendar__tile--active':'companyimagesq'} onClick={() => this.selectCompanyInfoImage(i)}><div class="noimage">{x.length>0 ? <img src={x} alt="" width="110px" height="110px"/> : <></>}</div></div>)}
          </th></tr></thead></table>
        </div>
        
        <div style={{display: "flow-root"}}>
          <h4>{company.name}</h4><div dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(company.description)}}></div>
          <div class="avrate">
            <h5 class="avrate2">Рейтинг по оценкам:</h5><span className="star5"/><span className="star5 starbw" style={{clip: "rect(0px 150px 30px "+((company.rating??0)*30).toString()+"px)"}}/>
          </div>
          <div><h4>Лучшие предложения:</h4><div className="companyinfogroup">{this.state.companyInfo.resources.map(res =>
            <div className='companyresourcesq'><div class="noimage">{res.images && res.images.length && res.images[0].length>0 ? <img src={"{{mainApiUrl}}"+res.images[0]} alt="" width="110px" height="110px"/> : <></>}</div>
              {/*res.rating===null*/false?<></>:<div class="compresrate"><span class="starsm5"></span><span class="starsm5 starbw" style={{clip: "rect(0px 100px 20px "+(res.rating*20).toString()+"px)"}}></span></div>}
            </div>)}
          </div></div>
        </div>
      </div>
      <div><h4>Отзывы</h4><div className="companyinfogroup">
        <div>
          {this.state.companyInfo.feedback.map(f => <div className="feedback"><div><b>{f.userName}</b></div>{Array.from(Array(f.rating).keys()).map(i => <span className="starsm"/>)}{f.date}<div>{f.text}</div></div>)}
        </div>
      </div></div>
      <div><h4>Оставить отзыв</h4><div className="companyinfogroup2">
        <div>
          <label for="Input_CompanyDesc">Оценка:</label>{Array.from(Array(5).keys()).map(i => <span key={i} className={i >= this.state.companyInfo.userRating?"starbw star":"star"} onClick={() => this.selectCompanyUserRating(i + 1)}/>)}
        </div>
        <div class="form-group companyinfotextarea">
          <textarea class="form-control" type="text" id="Input_CompanyDesc" name="Input.CompanyDesc" value={this.state.companyInfo.userText} onChange={evt => this.updateMyCompanyFeedback(evt)}/>
        </div>
        <div>
          <label for="scheme-upload" class="btn btn-primary">
            <i class="fa fa-cloud-upload"></i> Upload photo
          </label>
          <input id="scheme-upload" onChange={this.addScheme.bind(this)} type="file"/>
          <input class="btn btn-primary" type="button" value="Submit" id="Button_Save" onClick={this.handleSubmitCompanyFeedback}/>
        </div></div>
      </div></>
    );
  }

  updateMyResourceFeedback(text) {
    this.setState(prevState => ({...prevState, resourceInfo: {...prevState.resourceInfo, userText: text.target.value}}));
  }

  async handleSubmitResourceFeedback() {
    const token = await authService.getAccessToken();
    var headers = !token ? {} : { 'Authorization': `Bearer ${token}` };
    const response = await fetch(`{{mainApiUrl}}api/resources/${this.state.resourceInfo.id}/feedback`, {
      method: "POST",
      headers: {
        ...headers,
        'Accept': 'application/json, text/plain',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ rating: this.state.resourceInfo.userRating, text: this.state.resourceInfo.userText })
    });


    const data = await response.json();
    var resourceInfo = this.state.resourceInfo;
    resourceInfo.feedback = [...resourceInfo.feedback, data];
    resourceInfo.userText = "";
    resourceInfo.userRating = 0;
    this.setState(prevState => ({...prevState, resourceInfo: resourceInfo}));
  }

  async onResourceInfoOpen(resourceId) {
    const token = await authService.getAccessToken();
    var url = `{{mainApiUrl}}api/resources/${resourceId}/feedback`;
    const response = await fetch(url, {
      headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
    });
    const data = await response.json();
    this.setState(prevState => ({...prevState, resourceInfo: {id: resourceId, selectedImage: 0, userRating: 0, rating: data.averageRating, feedback: data.feedbackList}}));
  }

  selectResourceUserRating(rating) {
    this.setState(prevState => ({...prevState, resourceInfo: {...prevState.resourceInfo, userRating: rating}}));
  }

  renderResourceInfo(resource) {
    return (
      <><div className="imagesqbig">
        <div class="imagesqbigleft">
          <img src={"{{mainApiUrl}}"+resource.images[this.state.resourceInfo.selectedImage]} alt="" class="schemecomp"/>
          {resource.images.length>0 ? <table className="table"><thead><tr><th>
            {resource.images.map((x, i) => <div className={this.state.resourceInfo.selectedImage === i?'companyimagesq react-calendar__tile--active':'companyimagesq'} onClick={() => this.selectResourceInfoImage(i)}><div class="noimage">{x.length>0 ? <img src={x} alt="" width="110px" height="110px"/> : <></>}</div></div>)}
          </th></tr></thead></table> : <></>}
        </div>
        <div style={{display: "flow-root"}}>
          <h4>{resource.name}</h4><div dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(resource.description)}}></div>
          <div class="avrate">
            <h5 class="avrate2">Рейтинг по оценкам:</h5><span className="star5"/><span className="star5 starbw" style={{clip: "rect(0px 150px 30px "+((this.state.resourceInfo.rating??0)*30).toString()+"px)"}}/>
          </div>
        </div>
      </div>
      <div><h4>Отзывы</h4><div className="companyinfogroup">
      <div>
        {this.state.resourceInfo.feedback.map(f => <div className="feedback"><div><b>{f.userName}</b></div>{Array.from(Array(f.rating).keys()).map(i => <span className="starsm"/>)}{f.date}<div>{f.text}</div></div>)}
      </div>
      </div></div>
      <div><h4>Оставить отзыв</h4><div className="companyinfogroup2">
        <div>
          <label for="Input_CompanyDesc">Оценка:</label>{Array.from(Array(5).keys()).map(i => <span key={i} className={i >= this.state.resourceInfo.userRating?"starbw star":"star"} onClick={() => this.selectResourceUserRating(i + 1)}/>)}
        </div>
        <div class="form-group">
          <textarea class="form-control companyinfotextarea" type="text" id="Input_CompanyDesc" name="Input.CompanyDesc" value={this.state.resourceInfo.userText} onChange={evt => this.updateMyResourceFeedback(evt)}/>
        </div>
        <div>
          <label for="scheme-upload" class="btn btn-primary">
            <i class="fa fa-cloud-upload"></i> Upload photo
          </label>
          <input id="scheme-upload" onChange={this.addScheme.bind(this)} type="file"/>
          <input class="btn btn-primary" type="button" value="Submit" id="Button_Save" onClick={this.handleSubmitResourceFeedback}/>
        </div>
      </div></div></>
    );
  }

  renderCompaniesTable() {
    return (
      <div style={{paddingBottom: "1rem", minHeight: "360px"}}>
        <div className="rightcompdiv">
          <YMaps>
            <Map width={"100%"} height={"100%"} onLoad={ymaps => this.mapOnLoad(ymaps)} onBoundschange={event => this.selectBounds(event)} state={{center: this.state.geoposition, zoom: this.state.zoom, bounds: this.state.bounds}}>
              <GeolocationControl options={{ float: "left" }} onClick={() => this.onGeoposition()}/>
              {this.state.companies.filter(company => company.locationX !== null && company.locationY !== null && (company.id === this.state.fixedCompanyId || this.state.fixedCompanyId === 0)).map((company, i) =>
                <Placemark key={i} geometry={[company.locationX, company.locationY]}
                           properties={{hintContent: company.name, balloonContent: `<div class="placemarkdiv"><img class="placemark" src="${company.images[0]}" width="100" height="100"/>${company.description ?? ''}</div>`, balloonContentHeader: `<div><spn>${company.name}</span> <a class="btn btn-primary" style="vertical-align: baseline;" href="booking/${company.id}all#filters">Забронировать</a></div>`}}
                           options={{iconLayout: 'default#image', iconImageHref: company.images[0], iconImageSize: [30, 30], iconImageOffset: [-15, -15], iconShape: {type: 'Circle', coordinates: [0, 0], radius: 15}}}
                           modules={['geoObject.addon.balloon', 'geoObject.addon.hint']}/>
              )}
            </Map>
          </YMaps>
        </div>
        <div className="leftcompdiv">
          {this.state.companies.filter(company => company.id === this.state.fixedCompanyId || this.state.fixedCompanyId === 0).map(company =>
            <div key={company.id} onClick={() => this.selectCompany(company.id)} className={this.state.companyId === company.id ? 'companysq react-calendar__tile--active' : 'companysq'}>
              <div class="compsmallimagesq">
              {company.rating === null ? <></> : <div class="comprate"><span class="starsm5"></span><span class="starsm5 starbw" style={{clip: "rect(0px 100px 20px " + (company.rating*20).toString() + "px)"}}></span></div>}
              <Popup ref={this.selectorRef}
                className="popup-info"
                trigger={open => (
                  <span className="iimage"></span>
                )}
                onOpen={() => this.onCompanyInfoOpen(company.id)}
                position="bottom center"
                repositionOnResize
                closeOnDocumentClick>
                {() => this.renderCompanyInfo(company)}
              </Popup>
              <div class="noimage">{company.images && company.images.length && company.images[0].length>0 ? <img src={"{{mainApiUrl}}"+company.images[0]} alt="" width="110px" height="110px"/> : <></>}</div>
              </div>
              <div class="companysqprice">{company.minPrice?`от ${company.minPrice} руб.`:`Не указана`}</div>
              <div class="comanysqname">{company.name}</div>
            </div>
          )}
        </div>
      </div>
    );
  }

  renderCategories() {
    return (
      <div className="tabledivbig">
          {this.state.categories.map(category =>
            <div key={category.id} onClick={() => this.addCategory(category.id, -1, category.defaultServiceId)} className={'categorysq ' + (this.state.categoryIds.length > 0 && this.state.categoryIds[0] === category.id?'react-calendar__tile--active':'')}>
              <span class="categoryimg" style={{backgroundImage: "url({{mainApiUrl}}category/"+category.id.toString()+".svg)"}}/><span class="categoryname">{category.name}</span>
            </div>
          )}
      </div>
    );
  }

  renderServicesTable() {
    const services = this.state.services.filter(service => service.id === this.state.serviceId);
    if (this.state.categoryIds.length === 0 && !this.state.companyId && !this.state.serviceSearch) {
      return <div class="serviceinfo"><span className="arrownone"/><span class="serviceinfotext">Для выбора услуги выберите категорию или компанию</span></div>;
    }
    return (
        <>
      <SideNav
        componentClass="servicepanel"
        className="leftpanel"
        expanded={this.state.expanded}
        onToggle={(expanded) => {
          this.setState({ expanded });
        }}
        >
        <SideNav.Toggle className="lefttoggle"/>
        <SideNav.Nav className="rightcontainer" selected={this.props.selected} expanded={this.state.servicesexpanded}>
          <table class="table table-striped flex-grow" aria-labelledby="tabelLabel"><tbody>
            {this.state.categoryLists.map((list, i) =>
              <>
              {list.map(category =>
                <><tr key={category.id} onClick={() => this.addCategory(category.id, i)} className={this.state.categoryIds.length > i + 1 && this.state.categoryIds[i + 1] === category.id?'react-calendar__tile--active':''}>
                  <td>{category.name}</td>
                </tr>
                <tr>
                  <td><table className='table' aria-labelledby="tabelLabel"><tbody>
                    {this.state.services.filter(service => service.categoryId === category.id).map(service =>
                      <tr key={service.id}><td style={{padding: "0 0 0 0", textAlign: "left"}} key={service.id} onClick={() => this.selectService(service.id)} class={this.state.serviceId === service.id?'react-calendar__tile--active':''}>
                    <span className="arrowint"/><span>{service.name}</span></td></tr>
                    )}
                  </tbody></table></td>
                </tr></>
              )}
              </>
            )}
            </tbody></table>
        <table className='table table-striped' aria-labelledby="tabelLabel">
          <tbody>
            {this.state.services.filter(service => this.state.categoryIds.length <= 0 || service.categoryId === this.state.categoryIds[0]).map(service =>
              <tr key={service.id} onClick={() => this.selectService(service.id)}>
                <td className={this.state.serviceId === service.id?'react-calendar__tile--active':''} style={{textAlign: "left"}}>{service.name}</td>
              </tr>
            )}
          </tbody>
        </table>
        </SideNav.Nav>
      </SideNav>
      {services.length == 0 ? <div class="selectservice" onClick={() => this.setState(prevState => ({...prevState, expanded: true}))}><span>Выберите услугу</span></div>:
        <div className="tablediv">
        {this.state.categoryLists.map((list, i) =>
          <><table className='table table-striped servicetab' aria-labelledby="tabelLabel">
            <tbody>
              {list.filter(c => c.id == services[0].categoryId).map(category =>
                <tr key={category.id} onClick={() => this.addCategory(category.id, i)}>
                  <td className={this.state.categoryIds.length > i + 1 && this.state.categoryIds[i + 1] === category.id?'react-calendar__tile--active':''} style={i==0?{paddingLeft: "2.5rem", border: "0"}:{border: "0"}}>{category.name}</td>
                </tr>
              )}
            </tbody>
          </table><div style={{float: "left"}}><span className="arrowright" style={{backgroundImage:this.state.expanded?"none":""}}/></div></>
        )}
        <table className='table table-striped servicetabmain' aria-labelledby="tabelLabel">
          <tbody>
            {this.state.services.filter(service => service.id === this.state.serviceId).map(service =>
              <tr key={service.id} onClick={() => this.selectService(service.id)}>
                <td className={this.state.serviceId === service.id?'react-calendar__tile--active':''} style={this.state.categoryLists.length==0 || this.state.categoryLists[0].filter(c => c.id == services[0].categoryId)==0 ? {paddingLeft: "2.5rem", border: "0"}:{border: "0"}}>{service.name}</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>}
      </>
    );
  }

  findMin(arr) {
    return Math.min(...arr.map(node => node.startTime>node.endTime?0:node.startTime));
  }

  findMax(arr) {
    return Math.max(...arr.map(node => node.startTime>node.endTime?2400:node.endTime));
  }

  isBlockedTime(pos, res, bookingInterval) {
    if (bookingInterval == 4) {
      return res.slots && res.slots.filter(s => s.day == Math.trunc(pos)).length == 0;
    }
    return (res.endTime>res.startTime && (pos<res.startTime/100 || pos>=res.endTime/100)) || (res.endTime<res.startTime && pos>=res.endTime/100 && pos<res.startTime/100);
  }

  renderCalendar() {
    const regionStyle = {
      //cursor: "default",
      border: "none",
      //background: "rgba(0, 255, 0, 0.5)",
      zIndex: 99
    };
    return (
      <div>
      <Calendar
        tileContent={({ date, view }) => view === 'month' ? this.getContent(date) : null}
        onChange={this.selectDate} onActiveStartDateChange={this.selectMonth} value={this.state.selectedDate}/>

      <div style={{paddingBottom: "0.3rem"}}><div class="searchimg"><i class="fa-solid fa-magnifying-glass fa-xl"></i></div><input class="form-control searchinput" type="text" id="Input_ResourceName" name="Input.ResourceName"
        value={this.state.resourceSearch !== undefined ? this.state.resourceSearch : ''}
        onChange={evt => {const val = evt.target.value; this.setState(prevState => ({...prevState, resourceSearch: val})); this.populateCalendarData();}}/>
      </div>
      {this.state.resources===null?<FormattedMessage id="loading"/>:<>
      {this.state.companyId ? this.state.regions.map((r, i) =>
        <ReactRegionSelect
          maxRegions={100}
          regions={r/*this.state.regions[i]*/}
          regionStyle={regionStyle}
          regionRenderer={this.regionRenderer}
          handles={null}
          onChange={this.onRegionChange}>
          <img src={"{{mainApiUrl}}"+this.state.resources.filter(res => res.companyImages)[0].companyImages[r[0].data.mapId - 1]} class="schemeimg"/>
        </ReactRegionSelect>
      ) : <></>}
      {this.state.resources.filter(res => !this.state.resourceId || this.state.resourceId === res.id).length > 0 ? <div><div class="tableverybig"><table className="table table-striped" style={{width: "auto"}} aria-labelledby="tabelLabel">
        <thead>
          <tr>
            {<th class="tablefix" style={{height: "200px"}}>{this.state.minBookingInterval <= 3 ? "Время" : "Дата"}</th>}
            {this.state.resources.filter(res => res.services.length > 0 && (!this.state.resourceId || this.state.resourceId === res.id)).map((res, i) =>
              <th key={i} style={{borderLeft: "0", padding: "0"}} onClick={() => this.selectResource(res.id)} className={this.state.resourceId === res.id?'react-calendar__tile--active':''}>
                <div class="resourcesq">
                  <div class="resourcesmallimagesq">
                  <Popup ref={this.selectorRef}
                    className="popup-info"
                    trigger={open => (
                      <span className="iimage"></span>
                    )}
                    onOpen={() => this.onResourceInfoOpen(res.id)}
                    position="bottom center"
                    repositionOnResize
                    closeOnDocumentClick>
                    {() => this.renderResourceInfo(res)}
                  </Popup>
                  <div class="noimagesm">{res.images && res.images.length && res.images[0].length>0 ? <img width="70px" height="70px" alt="" src={"{{mainApiUrl}}"+res.images[0]}/> : <></>}</div>
                  </div>
                  <div>{res.name}{res.count>1?" ("+res.count+")":""}</div>
                </div>
              </th>
            )}
          </tr>
        </thead>
        <tbody>
          {this.state.resourcedays.map(pos => this.RenderRow(pos + this.findMin(this.state.resources)/100))}
        </tbody>
      </table></div></div> : <h1><FormattedMessage id="noslots"/></h1>}
      </>}
      </div>
    );
  }

  renderFilters() {
    if (!this.state.serviceId && !this.state.companyId) {
      return <></>;
    }
    return (
      <><div id="filters">Фильтры</div>
      <div className="tabledivbig" style={{overflow: "visible"}}>
        {this.state.filters.map(res =>
          <div>{res.name ? <label>{res.name}</label> : <></>}<table class="table-filter"><tr>{res.items.map(p => 
            <td key={p.id} onClick={() => this.addFilter(p.id)} className={this.state.selectedFilters.includes(p.id)?'react-calendar__tile--active':''}>{p.name}</td>
          )}</tr></table></div>
        )}
        {this.state.serviceId ?
        <div style={{height: "45px"}}>
          <label style={{margin: '0 10px 10px 0'}}>Цена</label>
          <div class="form-control-slider">
            <MultiRangeSlider
              min={this.state.minPrice !== undefined ? this.state.minPrice : 0}
              max={this.state.maxPrice !== undefined ? this.state.maxPrice : 10000}
              onChange={({ min, max }) => {console.log(`min = ${min}, max = ${max}`); this.setState(prevState => ({...prevState, minPriceVal: min, maxPriceVal: max})); this.populateCalendarData();}}
            />
          </div>
        </div> : <></>}
        <div style={{height: "45px"}}>
          <label style={{margin: '0 10px 10px 0'}}>Рейтинг</label>
          <div class="form-control-slider">
            <MultiRangeSlider
              min={0}
              max={5}
              onChange={({ min, max }) => {console.log(`min = ${min}, max = ${max}`); this.setState(prevState => ({...prevState, minRatingVal: min, maxRatingVal: max})); this.populateCalendarData();}}
            />
          </div>
        </div>
      </div></>
    );
  }

  selectCity(newValue) {
    const locationX = newValue.mapPositionX1+(newValue.mapPositionX2-newValue.mapPositionX1)/2;
    const locationY = newValue.mapPositionY1+(newValue.mapPositionY2-newValue.mapPositionY1)/2;
    this.setState(prevState => ({...prevState, city: newValue, zoom: 8, geoposition: [locationX, locationY], bounds: [[newValue.mapPositionX1, newValue.mapPositionY1],[newValue.mapPositionX2,newValue.mapPositionY2]]}));
  }

  selectSort(newValue) {
    this.setState(prevState => ({...prevState, sort: newValue}));
    this.populateCompaniesData();
  }

  debounce(func, delay) {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        func.apply(this, args);  
      }, delay);
    };
  };

  async fetchOptions(inputValue, callback) {
    const token = await authService.getAccessToken();
    const response = await fetch(`{{mainApiUrl}}api/geo?filter=${encodeURIComponent(inputValue)}`, {
      headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
    });
    const data = await response.json();
    const mapped = data.map(d=>({value: d.name, label: d.name, mapPositionX1: d.mapPositionX1, mapPositionY1: d.mapPositionY1, mapPositionX2: d.mapPositionX2, mapPositionY2: d.mapPositionY2}));
    this.setState(prevState => ({...prevState, cities: mapped}));
    callback(mapped);
  }

  render() {
    let services = this.state.loading
      ? <p><em><FormattedMessage id="loading"/></em></p>
      : this.renderServicesTable();

    let calendar = this.state.services.filter(s => s.id === this.state.serviceId).length === 0 && !this.state.companyId ? <></> : this.renderCalendar();

    return (
      <div>
        <h4 id="tabelLabel">Система бронирования</h4>
        {this.renderCategories()}
        <div style={{paddingBottom: "1rem"}}><div class="searchimg"><i class="fa-solid fa-magnifying-glass fa-xl"></i></div>
          <AsyncSelect
              className="formselect2"
              classNamePrefix="select"
              cacheOptions
              defaultOptions={this.state.cities}
              placeholder="Search cities..."
              loadOptions={this.debouncedLoadOptions}
              noOptionsMessage={() => "No Cities Found"}
              onChange={(newValue) => this.selectCity(newValue)}
              value={this.state.city}
            />
        <input class="form-control searchinput2" type="text" id="Input_ServiceName" name="Input.ServiceName"
          value={this.state.serviceSearch !== undefined ? this.state.serviceSearch : ''}
          onChange={evt => {const val = evt.target.value; this.setState(prevState => ({...prevState, serviceSearch: val})); this.populateServicesData(); this.populateCompaniesData();}}
        /></div>
        <div>Услуги</div>
        <div class="maincont">
          {services}
          <div class="companysort"><span>Компании</span><span class='sortimg'></span>
            <div className={this.state.sort === 1?'sorticon react-calendar__tile--active':'sorticon'} onClick={() => this.selectSort(1)}><span className='sortpopimg'/></div>
            <div className={this.state.sort === 2?'sorticon react-calendar__tile--active':'sorticon'} onClick={() => this.selectSort(2)}><span className='sortpriceimg'/></div>
            <div className={this.state.sort === 3?'sorticon react-calendar__tile--active':'sorticon'} onClick={() => this.selectSort(3)}><span className='sortrateimg'/></div>
            <div className={this.state.sort === 4?'sorticon react-calendar__tile--active':'sorticon'} onClick={() => this.selectSort(4)}><span className='sortdistimg'/></div>
          </div>
          {this.renderCompaniesTable()}
          {this.renderFilters()}
          {calendar}
        </div>
      </div>
    );
  }

  async populateCurrentCity() {
    const token = await authService.getAccessToken();
    const response = await fetch(`{{mainApiUrl}}api/geo/coord?x=${this.state.geoposition[0]}&y=${this.state.geoposition[1]}`, {
      headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
    });
    const d = await response.json();
    if (!d) {
      return;
    }
    const mapped = ({value: d.name, label: d.name, mapPositionX1: d.mapPositionX1, mapPositionY1: d.mapPositionY1, mapPositionX2: d.mapPositionX2, mapPositionY2: d.mapPositionY2});
    this.setState(prevState => ({...prevState, cities: [mapped], city: mapped}));
  }

  async populateCompaniesData() {
    const token = await authService.getAccessToken();
    var url = `{{mainApiUrl}}api/companies`;
    if (this.state.serviceId > 0)
      url = `{{mainApiUrl}}api/companies/service/${this.state.serviceId}`;
    else if (this.state.categoryIds.length > 0)
      url = `{{mainApiUrl}}api/companies/servicecategory/${this.state.categoryIds[this.state.categoryIds.length - 1]}`;
    url += `?sort=${this.state.sort}`;
    if (this.state.serviceSearch)
      url += `&search=${this.state.serviceSearch}`;
    const response = await fetch(url, {
      headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
    });
    const data = await response.json();
    this.setState(prevState => ({...prevState, companies: data, companyId: data.filter(company => company.id === this.state.companyId).length > 0 ? this.state.companyId : 0}));
  }

  async populateCategoriesData() {
    const token = await authService.getAccessToken();
    var url = this.state.fixedCompanyId?`{{mainApiUrl}}api/services/companycategories/${this.state.fixedCompanyId}`: `{{mainApiUrl}}api/services/categories`;
    const response = await fetch(url, {
      headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
    });
    const data = await response.json();
    this.setState(prevState => ({...prevState, categories: data}));
  }

  async populateCategoriesList(categoryId) {
    const token = await authService.getAccessToken();
    var url = this.state.fixedCompanyId?`{{mainApiUrl}}api/services/companycategories/${this.state.fixedCompanyId}/${categoryId}`:`{{mainApiUrl}}api/services/categories/${categoryId}`;
    const response = await fetch(url, {
      headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
    });
    const data = await response.json();
    if (data.length > 0)
      this.setState(prevState => ({...prevState, categoryLists: [...this.state.categoryLists, data]}));
  }

  async populateServicesData(companyId) {
    if (companyId === undefined) companyId = this.state.companyId;
    const token = await authService.getAccessToken();
    if (this.state.categoryIds.length === 0 && !companyId && !this.state.serviceSearch) {
      this.setState(prevState => ({...prevState, services: [], loading: false}));
      return;
    }
    var url = companyId > 0 
      ? `{{mainApiUrl}}api/services/${companyId}`
      : `{{mainApiUrl}}api/services`;
    if (this.state.categoryIds.length > 0) {
      url += `?categoryId=${this.state.categoryIds[this.state.categoryIds.length - 1]}`;
      if (this.state.serviceSearch)
        url += `&search=${this.state.serviceSearch}`;
    } else if (this.state.serviceSearch)
      url += `?search=${this.state.serviceSearch}`;
    const response = await fetch(url, {
      headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
    });
    const data = await response.json();
    this.setState(prevState => ({...prevState, services: data, loading: false}));
  }

  async populateOrdersData(temporders) {
    const token = await authService.getAccessToken();
    var date = new Date(this.state.selectedDate.getTime() - this.state.selectedDate.getTimezoneOffset() * 60000);
    if(this.state.minBookingInterval === 4){
      date = new Date(this.state.selectedMonth.getTime() - this.state.selectedMonth.getTimezoneOffset() * 60000);
    }
    var url = this.state.companyId > 0
      ? `{{mainApiUrl}}api/services/${this.state.serviceId}/orders/${this.state.companyId}`
      : `{{mainApiUrl}}api/services/${this.state.serviceId}/orders`;
    url += `?date=${date.toLocaleDateString('en-US')}&minBookingInterval=${this.state.minBookingInterval}`;
    const response = await fetch(url, {
      headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
    });
    const data = await response.json();
    if (temporders) {
      this.setState(prevState => ({...prevState, temporders: data}));
    } else {
      this.setState(prevState => ({...prevState, orders: data}));
    }
  }

  async populateResourcesData() {
    const token = await authService.getAccessToken();
    var date = new Date(this.state.selectedDate.getTime() - this.state.selectedDate.getTimezoneOffset() * 60000);
    const filter = this.state.selectedFilters.map(f => 'filter=' + f.toString()).join('&');
    var url = this.state.companyId > 0 
      ? `{{mainApiUrl}}api/services/${this.state.serviceId}/resources/${this.state.companyId}`
      : `{{mainApiUrl}}api/services/${this.state.serviceId}/resources`;
    url += `?${filter}&date=${date.toLocaleDateString('en-US')}`;
    if (this.state.minPriceVal)
      url += `&minPrice=${this.state.minPriceVal}`;
    if (this.state.maxPriceVal)
      url += `&maxPrice=${this.state.maxPriceVal}`;
    if (this.state.resourceSearch)
      url += `&search=${this.state.resourceSearch}`;
    const response = await fetch(url, {
      headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
    });
    const data = await response.json();
    var regions = [];
    if (this.state.companyId && data.filter(r => r.companyImages.length > 0).length > 0) {
      regions = data.map(r => r.mapId).filter((value, index, array) => value !== null && array.indexOf(value) === index).map((mapId, ind) => {
        return data.filter(r => r.mapId === mapId && r.locationX !== null).map((r, i) => { return {x: r.locationX, y: r.locationY, width: r.locationWidth, height: r.locationHeight, data: {index: i, resource: r, mapId: mapId, mapIndex: ind}, isChanging: false, new: true}});
      });
    }
    const resourcedays = data.length > 0 ? Array.from(Array((this.findMax(data) - this.findMin(data))/100).keys()) : [];
    this.setState(prevState => ({...prevState, regions: regions, resources: data, resourcedays: resourcedays, resourceId: null}));
  }

  async populateCalendarData(temporders, notclear) {
    if (!this.state.serviceId && !this.state.companyId){
      this.setState(prevState => ({...prevState, calendar: [], resources: [], orders: []}));
      return;
    }
    if (!notclear) {
      this.setState(prevState => ({...prevState, regions: [], resources: null, resourceId: null}));
    }
    const token = await authService.getAccessToken();
    var month = new Date(this.state.selectedMonth);
    month.setDate(1);
    month = new Date(month.getTime() - month.getTimezoneOffset() * 60000);
    const filter = this.state.selectedFilters.map(f => 'filter=' + f.toString()).join('&');
    var url = this.state.companyId > 0 
      ? `{{mainApiUrl}}api/services/${this.state.serviceId}/resourcescalendar/${this.state.companyId}`
      : `{{mainApiUrl}}api/services/${this.state.serviceId}/resourcescalendar`;
    url += `?${filter}&month=${month.toLocaleDateString('en-US')}`;
    if (this.state.minPriceVal)
      url += `&minPrice=${this.state.minPriceVal}`;
    if (this.state.maxPriceVal)
      url += `&maxPrice=${this.state.maxPriceVal}`;
    if (this.state.resourceSearch)
      url += `&search=${this.state.resourceSearch}`;
    const response = await fetch(url, {
      headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
    });
    const data = await response.json();

    const min = Math.min(...data.map(d => Math.min(...d.slots.map(slot => slot.service.bookingInterval), 5)), 5);
    this.setState(prevState => ({...prevState, calendar: data, minBookingInterval: min}));

    if (min < 4) {
      this.populateResourcesData();
    } else {
      const res = [];
      for (var d = 0; d < data.length; d++) {
        for (var s = 0; s < data[d].slots.length; s++) {
          const slot = data[d].slots[s];
          const found = res.filter(r => r.id === slot.id);
          const oneday = 24*60*60*1000;
          const day = Math.round((new Date(data[d].day)-month)/oneday+1);
          if (day <= 0) continue;
          if (found.length == 0) {
            res.push(({id: slot.id, name: slot.name, images: slot.images, companyImages: slot.companyImages, count: slot.count, localTime: slot.localTime, selivery: slot.delivery, deliveryPrice: slot.deliveryPrice, deliveryBillingTime: slot.deliveryBillingTime, services: [slot.service], slots: [{day: day, minTime: slot.service.minTime, price: slot.service.price, additionalPayments: slot.service.additionalPayments, firstIntervalPrice: slot.service.firstIntervalPrice, firstIntervalPriceIntervals: slot.service.firstIntervalPriceIntervals}], startTime: day*100, endTime: (day)*100}));
          } else {
            found[0].slots.push({day: day, minTime: slot.service.minTime, price: slot.service.price, additionalPayments: slot.service.additionalPayments, firstIntervalPrice: slot.service.firstIntervalPrice, firstIntervalPriceIntervals: slot.service.firstIntervalPriceIntervals});
            if (new Date(data[d].day).getMonth() == month.getMonth()) {
              if (day*100 < found[0].startTime) found[0].startTime = day*100;
              if (day*100 > found[0].endTime) found[0].endTime = (day)*100;
            }
          }
        }
      }
      console.log(res);
      const resourcedays = res.length > 0 ? Array.from(Array((this.findMax(res) - this.findMin(res))/100+1).keys()) : [];
      this.setState(prevState => ({...prevState, resources: res, resourcedays: resourcedays}));
    }
    await this.populateOrdersData(temporders);
  }

  async populateFiltersData() {
    if (!this.state.serviceId && !this.state.companyId){
      this.setState(prevState => ({...prevState, filters: []}));
      return;
    }
    const token = await authService.getAccessToken();
    var url = this.state.companyId > 0
      ? `{{mainApiUrl}}api/companies/resourceparamgroups/${this.state.companyId}`
      : `{{mainApiUrl}}api/companies/resourceparamgroups/0/${this.state.serviceId}`;
    url += `?hideempty=true`;
    const response = await fetch(url, {
      headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
    });
    const data = await response.json();
    const selfil = this.state.selectedFilters.filter(sf => {
      let found = false;
      data.forEach(f => {
        found = found || f.items.filter(i => i.id === sf).length > 0;
      });
      return found;
    });
    this.setState(prevState => ({...prevState, filters: data, selectedFilters: selfil}));
  }

  /*async populateUserData() {
    const token = await authService.getAccessToken();
    const response = await fetch(`{{mainApiUrl}}api/users/phone?phone=${encodeURIComponent(this.state.phone)}`, {
      headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
    });
    const data = await response.json();

    const response2 = await fetch(`{{userApiUrl}}api/users/phone?phone=${encodeURIComponent(this.state.phone)}`, {
      headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
    });
    const data2 = await response2.json();
    this.setState(prevState => ({...prevState, globalUsersMain: data, globalUsersIdentity: data2, userName: data.length == 1 ? data[0].firstName : this.state.userName}));
  }*/
}
